import { tokens } from '../../../_generated/token';
import { TOKEN_NOT_FOUND_CSS_VAR } from './constants';
export const token = (path, fallback) => {
  let token = tokens[path];
  if (typeof process !== 'undefined' && process.env.NODE_ENV !== 'production') {
    if (!token) {
      console.warn("Unknown token found: ".concat(path, " in @amzn/stencil-design-tokens"));
      token = TOKEN_NOT_FOUND_CSS_VAR;
    }
  }
  const resolvedToken = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
  return resolvedToken;
};